import { DataService } from './dataService'
export const creditNoteService = {

    getCreditList: async (data) => {
        return DataService.get('/admin/get_credit_note', data)
    },
    creditNoteCreate: async (data) => {
        return DataService.post('/admin/qbook/creditNoteCreate', data)
    },
    addCreditNote: async (data) => {
        return DataService.post('/admin/add_credit_note', data)
    },
    editCreditNote: async (data) => {
        return DataService.post('/admin/qbook/editCreditNote', data)
    },
    creditNoteEdit: async (data) => {
        return DataService.post('/admin/edit_credit_note', data)
    },
    deleteCreditNote: async (data) => {
        return DataService.post('/admin/qbook/deleteCreditNote', data)
    },
    creditNoteDelete: async (data) => {
        return DataService.post('/admin/delete_credit_note', data)
    },
    getUserList: async (data) => {
        return DataService.get('/admin/get_users', data)
    },
    getJobTokenList: async (data) => {
        return DataService.get('/admin/get_job_token_list', data)
    },
    deleteVendor: async (data) => {
        return DataService.post('/admin/delete_vendor', data)
    },
    getVendorDetails: async (data) => {
        return DataService.get('/admin/get_vendor_details', data)
    },
    update_vendor_status: async (data) => {
        return DataService.post('/admin/update_vendor_status', data)
    },


}
